export class Challenge {
  challenge: string
  expiresAt: string

  constructor({ challenge, expiresAt }: { challenge: string, expiresAt: string }) {
    this.challenge = challenge
    this.expiresAt = expiresAt
  }
}
